"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfExpirationDatesFailingPropsDto = instanceOfExpirationDatesFailingPropsDto;
exports.ExpirationDatesFailingPropsDtoFromJSON = ExpirationDatesFailingPropsDtoFromJSON;
exports.ExpirationDatesFailingPropsDtoFromJSONTyped = ExpirationDatesFailingPropsDtoFromJSONTyped;
exports.ExpirationDatesFailingPropsDtoToJSON = ExpirationDatesFailingPropsDtoToJSON;
exports.ExpirationDatesFailingPropsDtoToJSONTyped = ExpirationDatesFailingPropsDtoToJSONTyped;
/**
 * Check if a given object implements the ExpirationDatesFailingPropsDto interface.
 */
function instanceOfExpirationDatesFailingPropsDto(value) {
    if (!('expirationDates' in value) || value['expirationDates'] === undefined)
        return false;
    return true;
}
function ExpirationDatesFailingPropsDtoFromJSON(json) {
    return ExpirationDatesFailingPropsDtoFromJSONTyped(json, false);
}
function ExpirationDatesFailingPropsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expirationDates': json['expirationDates'],
    };
}
function ExpirationDatesFailingPropsDtoToJSON(json) {
    return ExpirationDatesFailingPropsDtoToJSONTyped(json, false);
}
function ExpirationDatesFailingPropsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'expirationDates': value['expirationDates'],
    };
}
//# sourceMappingURL=ExpirationDatesFailingPropsDto.js.map